<template>
	<div>
		<div class="d-flex justify-content-between">
			<h1 class="page-header">
				{{
					$t('teachingCalendar.page_title')
				}}
			</h1>
			<ts-breadcrumb :items="[
						{ text: $t('toHomePage'), href: '/' },
						{
							text: $t(
								'teachingCalendar.page_title'
							),
							active: true
						}
					]" />
		</div>
		<ts-card>
			<ts-card-wrapper>
				<div class="row">
					<div class="col-md-2 form-group ts-px-2">
						<label class="form-col-label control-label ts-mb-2 required">{{
							$t('teachingCalendar.dateRang')
						}}</label>
						<a-range-picker format="DD-MM-YYYY" :defaultValue="rangeDate" :defaultPickerValue="rangeDate"
							@change="dateRangeChange">
							<template slot="renderExtraFooter"></template>
						</a-range-picker>
					</div>
					<div class="col-md-10 ts-text-right ts-pt-6">
						<ts-button outline class="ml-2" v-tooltip="$t('filter')" @click.prevent="visible = true">
							<i class="fa fa-filter"></i>
						</ts-button>
					</div>
				</div>
				<a-drawer :title="$t('teachingCalendar.filter')" placement="right" :closable="false" :visible="visible"
					@close="() => (visible = false)" :zIndex="1020" width="300px">
					<div class="row form-group ts-mb-2">
						<div class="col-md-12">
							<label class="col-form-label col-md-12" style="margin-left: -12px;">
								{{ $t('teachingCalendar.acYear') }}
							</label>
							<a-radio-group v-model="acStatusId" @change="onStatusChange" size="small">
								<a-radio-button :value="1">
									{{ $t('teachingCalendar.current') }}
								</a-radio-button>
								<a-radio-button :value="2">
									{{ $t('teachingCalendar.history') }}
								</a-radio-button>
							</a-radio-group>
							<a-select style="width: 100%" v-model="ac_year_id" :options="years" showSearch mode="multiple"
								:filterOption="(input, option) =>
									option.componentOptions.children[0].text
										.toLowerCase()
										.indexOf(input.toLowerCase()) >= 0
									" :maxTagCount="1" :maxTagTextLength="17" :placeholder="$t('all')" @change="onChangeAcYear">
							</a-select>
						</div>
					</div>
					<div class="row ts-mt-4">
						<div class="col-md-12">
							<label>{{ $t('teachingCalendar.term') }}</label>
							<div class="form-group ts-w-full">
								<a-select style="width: 100%" v-model="ac_term_id" :options="terms" showSearch
									mode="multiple" :filterOption="(input, option) =>
										option.componentOptions.children[0].text
											.toLowerCase()
											.indexOf(input.toLowerCase()) >= 0
										" :maxTagCount="1" :maxTagTextLength="17" :placeholder="$t('all')">
								</a-select>
							</div>
						</div>
					</div>
				</a-drawer>
			</ts-card-wrapper>
			<div class="overflow-auto">
				<ts-table :columns="columns" :records="resources" :loading="loading">
					<template v-slot="{ record }">
						<td class="text-center">
							{{ record.date }}
						</td>
						<td class="text-center">
							{{ tConvert(record.time_from) + ' - ' + tConvert(record.time_to) }}
						</td>
						<td>
							{{ record.class ? record.class.class_name : '' }}
						</td>
						<td>
							{{ record.class.grade ? record.class.grade.grade_name_foreign : '' }}
						</td>
						<td>
							{{ record.subject ? record.subject.subject_name_foreign : '' }}
						</td>
						<td>
							{{ record.teacher ? (record.teacher.full_name_en) : '' }}
						</td>
						<td class="text-center">
							{{ record.class.room ? record.class.room.room_name : '' }}
						</td>
						<td>
							{{ record.old_teacher ? (record.old_teacher.full_name_en) : '' }}
						</td>
						<td>
							{{ record.remark }}
						</td>
						<td class="text-center">
							<a href="#" v-tooltip="'Edit'"
								v-show="record.schedule_date >= new Date().toJSON().slice(0, 10).replace(/-/g, '-')"
								class="mr-2 text-primary" @click.prevent="onEdit(record)">
								<i class="fas fa-edit"></i>
							</a>
						</td>
					</template>
				</ts-table>
			</div>
			<div class="d-flex justify-content-end p-15">
				<ts-pagination v-model="pagination" @navigate="fetchData"></ts-pagination>
			</div>
		</ts-card>
		<a-modal v-model="show_edit" :title="$t('teachingCalendar.page_title')" :zIndex="1020" :footer="null"
			:maskClosable="false" width="30%">
			<edit-component ref="edit_component" @close="() => (show_edit = false)" @fetchData="fetchData" />
		</a-modal>
	</div>
</template>
  
<script>

import { mapState, mapActions, mapGetters } from 'vuex'
import moment from 'moment'
import EditComponent from './edit'
import { debounce } from 'lodash'

export default {
	name: 'teaching-calendar',
	components: {
		EditComponent
	},
	data() {
		return {
			loading: false,
			visible: false,
			show_edit: false,
			years: [],
			terms: [],
			rangeDate: [moment().add(-1, 'Month'), moment()],
			columns: [
				{
					name: this.$t('teachingCalendar.date'),
					style: 'text-align:center; width:8%'
				},
				{
					name: this.$t('teachingCalendar.scheduleTime'),
					style: 'text-align:center; width:12%'
				},
				{
					name: this.$t('teachingCalendar.className')
				},
				{
					name: this.$t('teachingCalendar.grade')
				},
				{
					name: this.$t('teachingCalendar.subject')
				},
				{
					name: this.$t('teachingCalendar.teacher')
				},
				{
					name: this.$t('teachingCalendar.room'),
					style: 'text-align:center;width:12%'
				},
				{
					name: this.$t('teachingCalendar.substituteFrom')
				},
				{
					name: this.$t('teachingCalendar.remark')
				},
				{
					name: this.$t('teachingCalendar.action'),
					style: 'text-align:center; width:7%'
				}
			]
		}
	},
	computed: {
		...mapState('teachingCalendar', ['resources', 'pagination']),
		...mapGetters('teachingCalendar', ['tConvert']),
		ac_year_id: {
			get() {
				return this.$store.state.teachingCalendar.ac_year_id
			},
			set(newValue) {
				this.$store.commit('teachingCalendar/SET_YEAR_ID', newValue)
			}
		},
		ac_term_id: {
			get() {
				return this.$store.state.teachingCalendar.ac_term_id
			},
			set(newValue) {
				this.$store.commit('teachingCalendar/SET_TERM_ID', newValue)
			}
		},
		acStatusId: {
			get() {
				return this.$store.state.teachingCalendar.ac_status_id
			},
			set(newValue) {
				this.$store.commit(
					'teachingCalendar/SET_AC_STATUS',
					newValue
				)
			}
		}
	},
	created() {
		this.fetchData();
		this.fetchYear();
	},
	methods: {
		...mapActions('teachingCalendar', ['getYear', 'getTerm']),
		fetchData(attributes) {
			this.loading = true
			this.$store
				.dispatch('teachingCalendar/fetch', attributes)
				.then(() => {
					this.loading = false
				})
				.catch(error => {
					this.loading = false
					this.$toasted.error(error.message)
				})
		},
		onStatusChange() {
			this.years = []
			this.terms = []
			this.ac_year_id = undefined
			this.ac_term_id = undefined
			this.fetchYear()
		},
		onChangeAcYear() {
			this.terms = []
			this.ac_term_id = undefined
			this.fetchTerm()
		},
		fetchTerm() {
			this.loading = true
			this.getTerm({ ac_year_id: this.ac_year_id })
				.then(response => {
					this.terms = response.data.map(el => ({
						value: el.ac_term_id,
						label: el.term_name
					}))
				})
				.catch(error => {
					this.$toasted.error(error.message)
				})
				.finally(() => {
					this.loading = false
				})
		},
		fetchYear() {
			this.loading = true
			this.getYear()
				.then(response => {
					this.years = response.data.map(el => ({
						value: el.ac_year_id,
						label: el.ac_year
					}))
				})
				.catch(error => {
					this.$toasted.error(error.message)
				})
				.finally(() => {
					this.loading = false
				})
		},
		dateRangeChange(dateRange) {
			this.$store.commit(
				'teachingCalendar/SET_DATE_FROM',
				dateRange[0].format('DD-MM-YYYY')
			)
			this.$store.commit(
				'teachingCalendar/SET_DATE_TO',
				dateRange[1].format('DD-MM-YYYY')
			)
			this.fetchData()
		},
		onEdit(items) {
			this.show_edit = true;
			this.$store.commit("teachingCalendar/SET_EDIT_DATA", items);
			this.$refs.edit_component.setEditData();
		}
	},
	watch: {
		rangeDate: function () {
			this.fetchData()
		},
		ac_year_id: debounce(function (value) {
			this.fetchData({ ac_year_id: value })
		}, 500),
		ac_term_id: debounce(function (value) {
			this.fetchData({ ac_term_id: value })
		}, 500)
	}
}
</script>
  